/**
 * Alaska Gift — Product Recommendations
 * Fetches Shopify Product Recommendations API and replaces fallback grid.
 * Depends on: global.js (AlaskaUtils), product-cards.js (for add-to-cart event delegation)
 */

(() => {
  const grid = document.getElementById('pdp-recommendations');
  if (!grid) return;

  const productId = grid.dataset.productId;
  const baseUrl = grid.dataset.recommendationsUrl;
  if (!productId || !baseUrl) return;

  const url = `${baseUrl}.json?product_id=${productId}&limit=3&intent=related`;

  const bagIcon = grid.dataset.bagIcon || '';

  function escapeHTML(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function buildCard(p) {
    const title = escapeHTML(p.title);
    const handle = encodeURIComponent(p.handle);
    const imgUrl = p.featured_image ? escapeHTML(p.featured_image) : '';
    const img = imgUrl
      ? `<img class="product-card__image" src="${imgUrl}" srcset="${imgUrl}&width=200 200w, ${imgUrl}&width=300 300w, ${imgUrl}&width=408 408w" sizes="(max-width: 1024px) 50vw, 408px" loading="lazy" width="408" height="309" alt="${title}">`
      : '';
    const tag = p.product_type ? escapeHTML(p.product_type) : '';
    const variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
    const rootUrl = (window.routes && window.routes.root_url) || '/';

    return `<div class="product-card">
      <div class="product-card__info">
        <div class="product-card__top">
          ${tag ? `<span class="product-card__tag">${tag}</span>` : ''}
          <h3 class="product-card__name">
            <a href="${rootUrl}products/${handle}" class="product-card__link">${title}</a>
          </h3>
        </div>
        <span class="product-card__price">${AlaskaUtils.formatMoney(p.price)}</span>
      </div>
      <div class="product-card__image-wrapper">${img}</div>
      <button class="product-card__add-to-cart" data-product-id="${variantId}" type="button" aria-label="Add ${title} to cart">
        <span>Add to Cart</span>
        <span class="product-card__add-icon">${bagIcon}</span>
      </button>
    </div>`;
  }

  fetch(url)
    .then(r => { if (!r.ok) throw new Error('Recommendations fetch failed'); return r.json(); })
    .then(data => {
      const products = data.products;
      if (!products || products.length === 0) return;
      grid.innerHTML = products.map(buildCard).join('');
    })
    .catch(() => {
      /* Keep fallback collection products on error */
    });
})();
